import React, { useEffect, useState } from "react";
import gsap from "gsap";
import Image from "next/image";

const PreLoader: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Ensure component is mounted
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (!isLoaded) return;

    const tl = gsap.timeline();

    // Preloader Animation
    const preLoaderAnim = () => {
      // Wait a tiny bit to ensure DOM elements are ready
      setTimeout(() => {
        tl.to(".svg-container", {
          duration: 0.3,
          opacity: 1,
          ease: "Power3.easeOut",
        })
          .from(
            ".elite-svg",
            {
              duration: 1.2,
              y: 80,
              opacity: 0,
              ease: "Power3.easeOut",
            },
            0.3
          )
          .from(
            ".sun-svg",
            {
              duration: 1.2,
              y: 80,
              opacity: 0,
              ease: "Power3.easeOut",
            },
            0.6
          )
          .to("body", {
            duration: 0.01,
            css: { overflowY: "scroll" },
            ease: "power3.inOut",
          })
          .to(
            ".preloader",
            {
              duration: 1.5,
              height: "0vh",
              ease: "Power3.easeOut",
              onComplete: mobileLanding,
            },
            "+=0.5"
          )
          .to(".preloader", {
            duration: 0,
            css: { display: "none" },
          });
      }, 100);
    };

    const mobileLanding = () => {
      if (window.innerWidth < 763) {
        tl.from(".landing__main2", {
          duration: 1,
          delay: 0,
          opacity: 0,
          y: 80,
          ease: "expo.easeOut",
        });
      }
    };

    preLoaderAnim();
  }, [isLoaded]); // Empty dependency array to run the animation only on mount

  return (
    <div
      className="preloader gap-[5px] overflow-hidden text-[14px] sm:gap-[10px] sm:text-[16px] md:text-[18px] lg:text-[20px]"
      style={{
        height: "100vh",
        width: "100%",
        background: "#000000",
        color: "#e5ebf2",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 55,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden !important",
      }}
    >
      <div
        className="svg-container flex flex-col items-center justify-center gap-8"
        style={{
          height: "auto",
          opacity: 0,
        }}
      >
        <img
          src="/elite.svg"
          alt="Elite"
          className="elite-svg"
          style={{
            width: "350px",
            height: "auto",
          }}
        />
        <img
          src="/sun.svg"
          alt="Sun"
          className="sun-svg"
          style={{
            width: "250px",
            height: "auto",
          }}
        />
        <div className="sub hidden"></div>
      </div>
    </div>
  );
};

export default PreLoader;
